import React from "react";
import styles from "./index.module.scss";
import ContentWrapper from "../../components/ContentWrapper";
import { Button, Card, Form, Input, Typography, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";
import { selectUserState } from "../../store/selectors/user";
import { apiCreateProject } from "../../services/project";
import { useNavigate } from "react-router";
import { RouterPaths } from "../../router/paths";

interface CreateProjectFormValues {
  displayName: string;
  description: string;
}

function CreateProjectPage() {
  const { token } = useSelector(selectUserState);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const onSubmit = React.useCallback(
    async (values: CreateProjectFormValues) => {
      setLoading(true);
      if (token && values.displayName?.length && values.description?.length) {
        const res = await apiCreateProject(token, values);

        if (res.status === 201) {
          message.success("Project created successfully!");
          navigate(RouterPaths.PROJECTS);
        } else {
          message.error("Failed to create project!");
        }
      }
      setLoading(false);
    },
    [token]
  );

  return (
    <ContentWrapper>
      <Typography.Title level={2}>Create new project</Typography.Title>
      <Card>
        <Form
          name="createProject"
          className={styles.form}
          onFinish={onSubmit}
          disabled={loading}
        >
          <Form.Item
            label="Display Name"
            name="displayName"
            rules={[{ required: true, message: "Please input display name!" }]}
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: "Please input description!" }]}
            labelCol={{ span: 24 }}
          >
            <TextArea style={{ resize: "none" }} />
          </Form.Item>
          <Form.Item labelCol={{ span: 24 }}>
            <Button type="primary" htmlType="submit">
              Create Project
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </ContentWrapper>
  );
}

export default CreateProjectPage;
